<section class="ubicaciones">
	<div class="ubicaciones-titulo">
		<img src="assets/images/banners/ubicaciones.jpg" alt="Ubicaciones" loading="lazy"/>
	</div>
	<h1>En cualquiera de nuestras tiendas te atenderemos con gusto</h1>
	<div class="ubicaciones-sucursales" *ngFor="let newItem of listaSucursales">
		<div>
			<img *ngIf=" newItem.fotografia.length > 0 " [src]="newItem.fotografia[0].base64" alt="{{ newItem.nombre }}" loading="lazy"/>
		</div>
		<div>
			<div><h1 class="color-purple">{{ newItem.nombre }}</h1></div>
			<div><p>{{ newItem.direccion }}</p></div>
			<div class="servicios" *ngIf="newItem.conServicios">
				<h4>Servicios:</h4>
				<p>
					<span class="color-purple-bold" style="margin-left: 10px;">Estética</span>
					<span class="color-purple-bold" style="margin-left: 20px;">Veterinaria</span>
				</p>
			</div>
			<div class="horarios"><p [innerHTML]="newItem.horarios"></p></div>
			<div class="telefonos">
				<p>
					<span [innerHtml]=" newItem.telefonos | safe:'html' "></span>
					<span style="margin-left: 20px;" [innerHtml]=" newItem.whatsapp | safe:'html' "></span>
				</p>
			</div>
		</div>
		<div>
			<a target="_blank" href="https://www.google.com/maps/search/?api=1&query=Pawerful {{newItem.nombre}}&query={{ newItem.posicion.lat }},{{ newItem.posicion.lng }}&query_place_id={{newItem.placeId}}" title="Ubicación de {{ newItem.nombre }}">
				<img src="assets/images/google-maps.png" alt="Ubicación de {{ newItem.nombre }}" loading="lazy"/>
			</a>
		</div>
	</div>
</section>